// extracted by mini-css-extract-plugin
module.exports = {"panelArea":"app_panelArea__X7oup","sectionPanels":"app_sectionPanels__1QB3_","chartArea":"app_chartArea__sKG3o","watermark":"app_watermark__wRF8Y","waterbtn":"app_waterbtn__2f-wm"};